// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__226xW","rotate":"Loader_rotate__-xqgy","dash":"Loader_dash__2_jkY"};